import { render, staticRenderFns } from "./DefaultList.vue?vue&type=template&id=23ef8ee0&scoped=true"
import script from "./DefaultList.vue?vue&type=script&lang=js"
export * from "./DefaultList.vue?vue&type=script&lang=js"
import style0 from "./DefaultList.vue?vue&type=style&index=0&id=23ef8ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef8ee0",
  null
  
)

export default component.exports